<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
        <navbar
          isBlur="blur  border-radius-lg my-3 py-2 start-0 end-0 mx-4 shadow"
          v-bind:darkMode="true"
          isBtn="bg-gradient-success"
        />
      </div>
    </div>
  </div>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
              <div class="card card-plain">
                <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">Acceso</h4>
                  <p class="mb-0">Introduzca sus credenciales para acceder a nuestro portal</p>
                </div>
                <div class="card-body">
                  <form role="form" @submit.prevent="">
                    <div class="mb-3">
                      <argon-input type="email" placeholder="Email" name="email" v-model="User.email" size="lg" />
                    </div>
                    <div class="mb-3">
                      <argon-input type="password" placeholder="Contraseña" name="password" v-model="User.password" size="lg" />
                    </div>
                    <argon-switch id="rememberMe">Recordar</argon-switch>

                    <div class="text-center">
                      <argon-button
                        class="mt-4"
                        color="danger"
                        fullWidth
                        size="lg"
                        @click="login"
                      >Acceder</argon-button>
                    </div>
                  </form>
                </div>
                <div class="px-1 pt-0 text-center card-footer px-lg-2">
                  <p class="mx-auto mb-4 text-sm">
                    ¿No tiene cuenta?
                    <a
                      href="javascript:;"
                      class="text-danger text-gradient font-weight-bold"
                    >Contacto</a>
                  </p>
                </div>
              </div>
            </div>
            <div
              class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column"
            >
              <div
                class="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                :style="{backgroundImage: `url('${imgLoyalty}')`,backgroundSize: 'cover', backgroundPosition: 'center center'}"
              >
                <span class="mask bg-gradient-danger opacity-6"></span>
                <!-- <h4
                  class="mt-5 text-white font-weight-bolder position-relative"
                >"Comunicado especial"</h4>
                <p
                  class="text-white position-relative"
                >"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."</p> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import Navbar from "@/examples/PageLayout/Navbar.vue";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonSwitch from "@/components/ArgonSwitch.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import imgLoyalty from "@/assets/img/loyalty.png";

import axios from 'axios';
const body = document.getElementsByTagName("body")[0];

export default {
  name: "signin",
  imgLoyalty,
  components: {
    Navbar,
    ArgonInput,
    ArgonSwitch,
    ArgonButton,
  },
  data(){
    return{
      imgLoyalty,
      User:{
        email:null,
        password:null
      }
    }
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
  methods:{
    goToDashboard(){
      this.$router.push('/dashboard-default')
    },
    login(){
      axios.post(this.$EndPoint+'users/login',{
        email:this.User.email,
        password:this.User.password
      })
      .then(result=>{
        localStorage.setItem('_Id', result.data._id);
        localStorage.setItem('AccountId', result.data.AccountId);
        localStorage.setItem('Email', result.data.Email);
        localStorage.setItem('Name', result.data.Name);
        localStorage.setItem('Token', result.data.Token);
        localStorage.setItem('IsLoggedIn',true);
        localStorage.setItem('Role', result.data.Type);
        if(result.data.Type=='Salesforce'){
          this.$router.push('/dashboard-sf')
        }else if(result.data.Type=='Manager'){
          this.$router.push('/dashboard-sfm')
        }else if(result.data.Type=='Account Manager'){
          this.$router.push('/dashboard-sfa')
        }else{
          this.$router.push('/dashboard')
        }
        
      })
      .catch(()=>{
        this.$swal({
          title: 'Credenciales incorrectas',
          icon:'error',
          color:'#b4243a',
          confirmButtonText:'Intentar nuevamente',
          buttonsStyling:false,
          customClass:{
            confirmButton:'btn btn-danger'
          },
          confirmButtonColor:'#b4243a',
          showClass: {
            popup: 'animate__animated animate__fadeInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__fadeOutUp'
          }
        })
      })
    }
  }
};
</script>
